import React from "react";
import icon from "../assets/apple-touch-icon.png";
import Register from "../components/register/Register";

const RegisterPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="flex justify-between">
        {/* Logo */}
        <div className="flex items-center space-x-1">
          <img src={icon} alt="icon" className="h-10 w-10 text-orange-500" />
          <h3 className="text-xl font-bold">Vaspay</h3>
        </div>
      </div>
      <Register />
    </div>
  );
};

export default RegisterPage;
